var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02 5.178a.5.5 0 000 .894L8.552 9.34a1 1 0 00.894 0l6.534-3.267a.5.5 0 000-.894L9.447 1.91a1 1 0 00-.894 0L2.019 5.178zm1.579 2.809a.5.5 0 00-.448 0l-1.02.51a.562.562 0 000 1.006l6.366 3.183c.317.158.69.158 1.006 0l6.366-3.183a.562.562 0 000-1.006l-1.02-.51a.5.5 0 00-.448 0l-4.898 2.449c-.317.158-.69.158-1.006 0l-4.898-2.45zm0 3.375a.5.5 0 00-.448 0l-1.02.51a.562.562 0 000 1.006l6.366 3.183c.317.158.69.158 1.006 0l6.366-3.183a.562.562 0 000-1.006l-1.02-.51a.5.5 0 00-.448 0L9.503 13.81c-.317.158-.69.158-1.006 0l-4.898-2.45z",
    fill: "#fff",
    opacity: 0.5
  })));
}
export default __webpack_public_path__ + "static/more.eb7f845e.svg";
export { SvgMore as ReactComponent };